import { render } from "./ClientInitiator.vue?vue&type=template&id=912d6910"
import script from "./ClientInitiator.vue?vue&type=script&lang=js"
export * from "./ClientInitiator.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__